import { departmentService } from "../../../../Api/Services/DepartmentService";
import { IEditDepartmentResponse } from "../../../../Types/Common";
import createGenericSlice from "../../../../utils/reduxUtils/createEntitySlice";
import createServiceAsyncThunk from "../../../../utils/reduxUtils/createServiceAsyncThunk";
import { ACTION_NAMES, SLICE_NAMES } from "../../../../constants/action";
import { ERROR_MESSAGES } from "../../../../constants/error";

// Thunk to fetch department data for editing
export const editDepartmentThunk = createServiceAsyncThunk<
  IEditDepartmentResponse,
  number
>(
  ACTION_NAMES.EDIT_DEPARTMENT,
  (id) => departmentService.getEditDepartment(id),
  ERROR_MESSAGES.EDIT_DEPARTMENT_FAILURE
);

// Slice
const editDepartmentSlice = createGenericSlice<IEditDepartmentResponse, number>(
  SLICE_NAMES.EDIT_DEPARTMENT,
  editDepartmentThunk
);

// Actions
export const {
  clearError: clearEditDepartmentError,
  clearSuccessMessage: clearEditDepartmentSuccess,
} = editDepartmentSlice.actions;

export default editDepartmentSlice.reducer;
